import axios from 'axios';
import type { Topic } from '@/models/topic';
import { ApprovalState } from '@/components/prine/enums/ApprovalState';
import { axiosV2 } from '@/main';

class TopicWebserviceV2 {
    public load() {
        return axios.get<Topic[]>('/topics');
    }

    public loadTopicsByTradeAndPhaseWithLessons(phaseId: number, approvalState: ApprovalState) {
        // Use the customAxios instance to make requests
        if (approvalState === ApprovalState.ALL) {
            return axiosV2.get<Topic[]>('topics/byTradeWithLessons', {
                params: {
                    phaseId,
                },
            });
        } else {
            return axiosV2.get<Topic[]>('topics/byTradeWithLessons', {
                params: {
                    phaseId,
                    approved: approvalState === ApprovalState.APPROVED ? 1 : 0,
                },
            });
        }
    }
}

export const topicWebserviceV2 = new TopicWebserviceV2();
